import type { IconComponent } from '@fourthwall/components'
import {
  ApparelIcon,
  ButtonIcon,
  ChecklistIcon,
  CodeIcon,
  CogIcon,
  CollectionAlt2Icon,
  CollectionAltIcon,
  EmailIcon,
  FooterIcon,
  HeaderIcon,
  ImageBannerIcon,
  ImageWithTextIcon,
  InstagramIcon,
  MegaphoneIcon,
  PhotoIcon,
  PostIcon,
  StarIcon,
  TagIcon,
  TikTokIcon,
  VideoBannerIcon,
  VideoIcon,
  VideoWithTextIcon,
  YoutubeIcon,
} from '@fourthwall/icons'

const iconMap: Record<string, IconComponent> = {
  'announcement-bar': MegaphoneIcon,
  content_for_header: CodeIcon,
  'collections-list': CollectionAltIcon,
  'custom-html': CodeIcon,
  debug: CogIcon,
  donations: TagIcon,
  'featured-collection': CollectionAlt2Icon,
  'featured-product': ApparelIcon,
  footer: FooterIcon,
  header: HeaderIcon,
  hero: ImageBannerIcon,
  'hero-video': VideoBannerIcon,
  'image-with-text': ImageWithTextIcon,
  image: PhotoIcon,
  'instagram-feed': InstagramIcon,
  'links-list': ButtonIcon,
  newsletter: EmailIcon,
  'recent-tiktoks': TikTokIcon,
  'recent-videos': YoutubeIcon,
  'rich-text': PostIcon,
  tiers: ChecklistIcon,
  video: VideoIcon,
  'video-with-text': VideoWithTextIcon,
  product: ApparelIcon,
  'product-recommendations': ApparelIcon,
  recommended: StarIcon,
}

export const getIcon = (sectionName: string): IconComponent => {
  return iconMap[sectionName] || PostIcon
}
